// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lxb0j","type":"styles_type__2nnCF","choices":"styles_choices__3bF2e"};